module.exports = __webpack_public_path__ + "img/icon-list-view-opacity.c4739f09.svg";